module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-teams",
    attrs: {
      "id": "section-sub-teams",
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div-container', [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile"
  }, [_c('div', {
    staticClass: "column is-11 is-12-mobile has-text-centered content content-competitions"
  }, _vm._l((_vm.competitions), function(competition) {
    return _c('span', {
      staticClass: "wrapper"
    }, [_c('a', {
      attrs: {
        "href": _vm.$route.path + '?team=' + competition.name_slug
      },
      on: {
        "click": function($event) {
          return _vm.onClickTeam($event, competition.name_slug)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "display": "inline-block",
        "padding": "5px",
        "vertical-align": "middle",
        "width": "40px",
        "max-height": "50px"
      },
      attrs: {
        "src": competition.image.path
      }
    }), _vm._v(" "), _c('h3', {
      staticStyle: {
        "display": "inline-block",
        "padding": "3px 16px"
      }
    }, [_c('span', {
      staticClass: "name",
      class: {
        'is-active': (competition.name_slug === _vm.filter)
      }
    }, [_vm._v(_vm._s(competition.name))])]), _c('br')])])
  }), 0), _vm._v(" "), (_vm.teams) ? _c('div', {
    staticClass: "column is-11 is-12-mobile has-text-centered content content-teams",
    staticStyle: {
      "padding-top": "0"
    }
  }, _vm._l((_vm.teams), function(team, index) {
    return (!team.hide) ? _c('div', {
      key: team.name_slug,
      staticClass: "columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile",
      class: {
        'is-alt': team.isAlt
      }
    }, [_c('div', {
      staticClass: "column is-8 has-text-centered"
    }, [_c('h3', {
      staticStyle: {
        "display": "inline-block",
        "padding": "16px 0px",
        "margin-bottom": "0"
      }
    }, [_vm._v(_vm._s(team.name))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "display": "inline-block",
        "padding": "16px 8px",
        "margin-bottom": "0",
        "font-weight": "normal"
      }
    }, [_vm._v("(" + _vm._s(team.city) + ", " + _vm._s(team.state) + ")")]), _c('br')]), _vm._v(" "), (team.competitions) ? _c('div', {
      staticClass: "column is-4 has-text-centered"
    }, _vm._l((team.competitions), function(competition) {
      return _c('img', {
        staticStyle: {
          "display": "inline-block",
          "padding": "5px",
          "vertical-align": "middle",
          "width": "40px",
          "max-height": "50px"
        },
        attrs: {
          "src": competition.image.path
        }
      })
    }), 0) : _vm._e()]) : _vm._e()
  }), 0) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-529ebad8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeamsSubSection.vue
// module id = 914
// module chunks = 1